export default __webpack_public_path__ + "static/media/loadingSpin.6b50de48.gif";